import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { RobnaGrupa } from './robna-grupa';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-robna-grupa-modal-update',
  templateUrl: './robna-grupa-modal-update.component.html'
})
export class RobnaGrupaModalUpdateComponent extends BaseModalUpdateComponent<RobnaGrupa> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<RobnaGrupa>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
